export const PREFIX = 'https://api.belong.education';
// export const PREFIX = 'http://localhost:5000';
// export const PREFIX = 'https://belong-api-placement-12i167x53.herokuapp.com';

export const UPLOAD_OR_DOWNLOAD_URL = `${PREFIX}/api/upload`;
